// eslint-disable-next-line import/no-unresolved
import { AppLoaderWrapper } from 'voxguru-v1/components/AppLoader/AppLoader.styles';
import { Flex } from '@chakra-ui/react';

function AppLoader({ isLoading, children, height = '90vh', customStyles }) {
  if (isLoading) {
    return (
      <Flex
        alignItems="center"
        justifyContent="center"
        height={height}
        {...customStyles}
      >
        <AppLoaderWrapper />
      </Flex>
    );
  }
  return children;
}

export default AppLoader;
